import { useContext } from "react";
import { OrderContext } from "./OrderProvider";

export default function OrderContactInfo() {
  const { state } = useContext(OrderContext);
  return (
    <div>
      <p className="main-form-headerLabel">I. Contact Information</p>
      {state.orderType === "2" ? <BulkOrderInfo /> : null}
      <SingleOrderInfo state={state} />
    </div>
  );
}

function SingleOrderInfo({ state }) {
  return (
    <div>
      <label htmlFor="full_name" className="main-form-label">
        {state.orderType === "1" ? "Full Name" : "Name of Representative"}{" "}
        <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="text"
        id="full_name"
        name="full_name"
        placeholder="Enter your full name"
        required
        className="main-form-input"
        maxLength="50"
      />

      <label htmlFor="birth_date" className="main-form-label">
        Birth Date <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="date"
        id="birth_date"
        name="birth_date"
        placeholder="Enter your birth date"
        required
        className="main-form-input"
      />

      <label htmlFor="gender" className="main-form-label">
        Gender <span style={{ color: "red" }}>*</span>
      </label>
      <select id="gender" name="gender" required className="main-form-input">
        <option value="" disabled selected hidden>
          Select gender
        </option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Non-Binary">Non-Binary</option>
      </select>

      <label htmlFor="contact_number" className="main-form-label">
        Contact Number <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="tel"
        id="contact_number"
        name="contact_number"
        placeholder="Enter your contact number"
        required
        className="main-form-input"
        maxLength="13"
      />

      <label htmlFor="email_address" className="main-form-label">
        Email Address <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="email"
        id="email_address"
        name="email_address"
        placeholder="Enter your email address"
        required
        className="main-form-input"
        maxLength="30"
      />
    </div>
  );
}

function BulkOrderInfo() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {/* <button
        type="button"
        className="main-form-btnDownload"
        onClick={DownloadTemplate}
      >
        Download Template
      </button> */}
      <div style={{ marginBottom: "10px" }}>
        {/* <p style={{ fontFamily: "Cinzel", color: "#7d3f26" }}>Upload Bulk</p> */}
        <i
          style={{
            fontFamily: "Cinzel",
            color: "#7d3f26",
            fontSize: "15px",
          }}
        >
          {/* Note: Do not add or remove any column in the template. */}
          For schools only, minimum of 30 students per booking.
        </i>
        <p
          style={{
            fontFamily: "Cinzel",
            color: "#7d3f26",
            fontSize: "15px",
          }}
        >
          *For bulk order, only cash payment is accepted.
        </p>
        {/* <input
          type="file"
          id="bulk_order_file"
          name="bulk_order_file"
          accept=".csv, .xlsx, .xls"
          className="main-form-input"
          style={{ marginTop: "10px" }}
        /> */}
      </div>
    </div>
  );
}
